import Mentions from './Mentions';
export default Mentions;


//////////////////
// WEBPACK FOOTER
// ../~/rc-mentions/es/index.js
// module id = 1977
// module chunks = 1